import script from "./OtpFrom.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpFrom.vue?vue&type=script&setup=true&lang=js"

import "./OtpFrom.vue?vue&type=style&index=0&id=51d6de1a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d6de1a"]])

export default __exports__